// extracted by mini-css-extract-plugin
export var content = "components-__Collapsible-module___content";
export var guest = "components-__Collapsible-module___guest";
export var guestContainer = "components-__Collapsible-module___guestContainer";
export var guestToggle = "components-__Collapsible-module___guestToggle";
export var guestToggleChevron = "components-__Collapsible-module___guestToggleChevron";
export var guestToggleText = "components-__Collapsible-module___guestToggleText";
export var isOpen = "components-__Collapsible-module___isOpen";
export var slide = "components-__Collapsible-module___slide";
export var toggle = "components-__Collapsible-module___toggle";